<template>
  <header class="header_area">
    <div class="header_inner">
      <ul class="header_left">
        <li>
          <div class="logo">
            <router-link :to="{ name: 'dashboard' }">
              <img :src="`${baseUrl}assets/images/logo.png`" alt="" />
            </router-link>
          </div>
        </li>
        <li
          :class="{
            active: [
              'members_admin',
              'member_admin_add',
              'member_admin_edit',
              'parent_list',
              'parent_add',
              'parent_edit',
              'student_list',
              'student_add',
              'student_edit',
              'professor_list',
              'professor_add',
              'professor_edit',
              'consultation_list',
              'consultation_add',
              'consultation_edit',
            ].includes($route.name),
          }"
        >
          <router-link :to="{ name: 'members_admin' }">{{
            $t('header.memberManagement')
          }}</router-link>
        </li>
        <li
          :class="{
            active: [
              'lecture_course_learning_list',
              'lecture_course_learning_add',
              'lecture_course_learning_edit',
              'thinking_skill_list',
              'thinking_skill_top_solution_add',
              'thinking_skill_top_solution_edit',
              'thinking_skill_add',
              'thinking_skill_thinking_ability_add',
              'thinking_skill_thinking_ability_edit',
              'thinking_skill_examination_add',
              'thinking_skill_edit',
              'thinking_skill_examination_edit',
              'holiday_systematic_mathematics_list',
              'holiday_systematic_mathematics_add',
              'holiday_systematic_mathematics_edit',
              'holiday_parochial_mathematics_list',
              'holiday_parochial_mathematics_add',
              'holiday_parochial_mathematics_edit',
              'holiday_convergence_mathematics_list',
              'holiday_convergence_mathematics_add',
              'holiday_convergence_mathematics_edit',
              'holiday_parent_special_lecture_list',
              'holiday_parent_special_lecture_add',
              'holiday_parent_special_lecture_edit',
              'holiday_enjoy_learning_list',
              'holiday_enjoy_learning_add',
              'holiday_enjoy_learning_edit',
              'test_lecture_list',
              'test_lecture_add',
              'test_lecture_edit',
              'lecture_video_list',
              'question_video_list',
            ].includes($route.name),
          }"
        >
          <router-link :to="{ name: 'lecture_course_learning_list' }">{{
            $t('header.lectureManagement')
          }}</router-link>
        </li>
        <li
          :class="{
            active: ['package_list', 'package_add', 'package_edit'].includes(
              $route.name
            ),
          }"
        >
          <router-link :to="{ name: 'package_list' }">{{
            $t('header.packageManagement')
          }}</router-link>
        </li>
        <li :class="{ active: ['orders', 'order_edit'].includes($route.name) }">
          <router-link :to="{ name: 'orders' }">{{
            $t('header.orderManagement')
          }}</router-link>
        </li>
        <li
          :class="{
            active: [
              'exam_questions',
              'exam_questions_add',
              'exam_questions_edit',
              'exam_management_exams',
              'exam_management_exam_add',
              'exam_management_exam_edit',
            ].includes($route.name),
          }"
        >
          <router-link :to="{ name: 'exam_questions' }">{{
            $t('header.exam_management')
          }}</router-link>
        </li>
        <li
          :class="{
            active: [
              'settings_lecture_category',
              'settings_lecture_category_add',
              'settings_lecture_category_edit',
              'settings_subject',
              'settings_subject_add',
              'settings_subject_edit',
              'settings_area',
              'settings_area_add',
              'settings_area_edit',
              'settings_thinking_area',
              'settings_thinking_area_add',
              'settings_thinking_area_edit',
              'settings_portion',
              'settings_portion_add',
              'settings_portion_edit',
              'settings_grade',
              'settings_grade_add',
              'settings_grade_edit',
              'settings_semesters',
              'settings_semester_add',
              'settings_semester_edit',
              'settings_week',
              'settings_week_add',
              'settings_week_edit',
              'settings_textbook_list',
              'settings_textbook_add',
              'settings_textbook_edit',
              'settings_connection_services',
              'settings_connection_service_add',
              'settings_connection_service_edit',
              'settings_chapter',
              'settings_chapter_add',
              'settings_chapter_edit',
              'settings_parkings',
              'settings_parking_add',
              'settings_parking_edit',
              'settings_difficulty',
              'settings_difficulty_add',
              'settings_difficulty_edit',
              'settings_point',
              'settings_point_add',
              'settings_point_edit',
              'settings_exam_type',
              'settings_exam_type_add',
              'settings_exam_type_edit',
              'home_banner',
              'notice_list',
              'notice_add',
              'notice_edit',
              'faq_list',
              'faq_add',
              'faq_edit',
              'faq_category_list',
              'faq_category_add',
              'faq_category_edit',
              'magazine_slider_list',
              'magazine_slider_add',
              'magazine_slider_edit',
              'unit_registration_list',
              'unit_registration_add',
              'unit_registration_edit',
              'settings_question_type',
              'settings_question_type_add',
              'settings_question_type_edit',
              'settings_folder_unit',
              'settings_folder_unit_add',
              'settings_folder_unit_edit',
              'settings_folder_grade',
              'settings_folder_grade_add',
              'settings_folder_grade_edit',
              'settings_folder_semester',
              'settings_folder_semester_add',
              'settings_folder_semester_edit',
              'home_banner_add',
              'home_banner_edit',
              'inquiry_type_list',
              'inquiry_type_add',
              'inquiry_type_edit',
              'landing_page_list',
              'landing_page_add',
              'landing_page_edit',
            ].includes($route.name),
          }"
        >
          <router-link :to="{ name: 'home_banner' }">{{
            $t('header.settings')
          }}</router-link>
        </li>
      </ul>
      <ul>
        <li>
          <a href="#">관리자 홈 / </a>
          <a href="#">회원정보/결재정보 / </a>
          <a href="#"> 교과학습</a>
        </li>
        <li>
          <div class="logout">
            <a href="javascript:void(0)" @click.prevent="logout">Logout</a>
          </div>
        </li>
      </ul>
    </div>
  </header>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE,
    };
  },
  computed: {
    ...mapGetters({
      user: 'auth/getUser',
    }),
  },
  mounted() {
    // $(document).on('click', '.dropdown button', function () {
    //     $(this).parent().children('.dropdown_menu').toggleClass('open');
    // });
    // $(document).mouseup(function (e) {
    //     $('.dropdown').each(function () {
    //         var dropdown = $(this);
    //         if (!dropdown.is(e.target) && dropdown.has(e.target).length === 0) {
    //             dropdown.find('.dropdown_menu').removeClass('open');
    //         }
    //     });
    // });
  },
  methods: {
    logout() {
      this.axios.post('/logout').finally(() => {
        this.$store.dispatch('auth/logout');
        this.$router.push({ name: 'login' });
      });
    },
  },
};
</script>
<style scoped></style>
